import { SelectResult } from './SelectResult';
export var PivotResult;
(function (PivotResult) {
    function get(plan, result, field) {
        switch (plan.type) {
            case "PIVOT_BASIC": {
                const query = plan.queries[0];
                return SelectResult.get(result, query);
            }
            case "PIVOT_DETAIL": {
                let level;
                if (field == null) {
                    return undefined;
                }
                if (typeof field === 'string') {
                    for (const part of plan.levels) {
                        if (part.name === field) {
                            level = part;
                            break;
                        }
                    }
                }
                else {
                    for (const part of plan.levels) {
                        if (part.name === field.alias) {
                            level = part;
                            break;
                        }
                    }
                }
                if (level == null) {
                    return undefined;
                }
                let query;
                for (const planQuery of plan.queries) {
                    if (planQuery.name === level.query) {
                        query = planQuery;
                        break;
                    }
                }
                if (query == null) {
                    return undefined;
                }
                return SelectResult.get(result, query);
            }
        }
    }
    PivotResult.get = get;
})(PivotResult || (PivotResult = {}));
